export interface Interactive {
    level: number;
    level1SawAnswer: boolean;
    level1Clear: boolean;
    level2Clear: boolean;
    level2SawAnswer: boolean;
    finished: boolean;
    routeAddress: string;
    newDay2ContentAddress: string;
}

export enum InteractiveContentPictureCounts {
    oldContent = 4,
    newContent = 3,
    firstNotification = 2,
    secondNotification = 5,
    androidSecondNotification = 7,
}

export enum contentSize {
    maxWidth = 400
}
